/**
 * ClosedEyeLashes — stylised closed-eye icon with downward lashes.
 * Matches the Pocketpills-style hidden-password affordance (a smooth
 * upper-lid crescent with three short lashes) rather than Lucide's
 * default `EyeOff` (a crossed-out eye).
 *
 * Import alongside Lucide's `Eye` for the "reveal" (visible) state:
 *   {visible ? <Eye /> : <ClosedEyeLashes />}
 */
export function ClosedEyeLashes({ className = "w-5 h-5", strokeWidth = 2, ...props }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
      {...props}
    >
      {/* Upper-lid crescent (closed eye) */}
      <path d="M3 10c3.2 4 6.2 6 9 6s5.8-2 9-6" />
      {/* Lashes */}
      <path d="M6 15l-1.5 2.2" />
      <path d="M10 16.6l-0.6 2.4" />
      <path d="M14 16.6l0.6 2.4" />
      <path d="M18 15l1.5 2.2" />
    </svg>
  );
}
